import { render } from "./user-profile.vue?vue&type=template&id=963408f0&scoped=true"
import script from "./user-profile.vue?vue&type=script&lang=js"
export * from "./user-profile.vue?vue&type=script&lang=js"

import "./user-profile.vue?vue&type=style&index=0&id=963408f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963408f0"]])

export default __exports__